const LOGGER_ENABLED_VAR = '@wippy_enable_logger';
export const isLoggerEnabled = () => {
  let _isLoggerEnabled = false;

  try {
    _isLoggerEnabled =
      _isLoggerEnabled || !!localStorage.getItem(LOGGER_ENABLED_VAR);
  } catch (e) {
    // ignore
  }

  return _isLoggerEnabled;
};
